export class ModelInterval {

    constructor(modelSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.name = data.name ?? null;
        this.description = data.description ?? null;
        this.notes = data.notes ?? null;
        this.modelSection = modelSection ?? null;
        this.elevationTop = data.elevationTop ?? null;
        this.elevationBottom = data.elevationBottom ?? null;
        this.verticalLevelTop = data.verticalLevelTop ?? null;
        this.verticalLevelBottom = data.verticalLevelBottom ?? null;
        this.thickness = data.thickness ?? null;
        this.isModelSectionTopInterval = data.isModelSectionTopInterval ?? null;
        this.isModelSectionBottomInterval = data.isModelSectionBottomInterval ?? null;
        this.geoSection = data.geoSection ?? null;
        this.geoLayer = data.geoLayer ?? null;
        this.waterBody = data.waterBody ?? null;
        this.isWithinWaterBody = data.isWithinWaterBody ?? null;
        this.hasBuoyancyEffectWhenUnderWater = data.hasBuoyancyEffectWhenUnderWater ?? null;
        this.isWithinWaterBodyAndHasBuoyancyEffect = data.isWithinWaterBodyAndHasBuoyancyEffect ?? null;
        this.waterIntervalTopDepth = data.waterIntervalTopDepth ?? null;
        this.waterIntervalBottomDepth = data.waterIntervalBottomDepth ?? null;
        this.isWaterBodySurface = data.isWaterBodySurface ?? null;
        this.waterIntervalPressureUzTop = data.waterIntervalPressureUzTop ?? null;
        this.waterIntervalIncreaseUzInc = data.waterIntervalIncreaseUzInc ?? null;
        this.waterIntervalPressureUzBottom = data.waterIntervalPressureUzBottom ?? null;
        this.isModelSectionMassTopInterval = data.isModelSectionMassTopInterval ?? null;
        this.load = data.load ?? null;
        this.boundary = data.boundary ?? null;
        this.object = data.object ?? null;

    }

    get elevationOfZeroDatumLevel() {
        return this.modelSection?.elevationOfZeroDatumLevel ?? null;
    }

    get waterBodyType() {
        return this.waterBody?.waterBodyType ?? null;
    }

    get waterUnitWeightGamaW() {
        return this.waterBody?.waterUnitWeightGamaW ?? null;
    }

    get waterBodyElevationTop() {
        return this.waterBody?.elevationTop ?? null;
    }

    get waterBodyPressureUzTop() {
        return this.waterBody?.waterBodyPressureUzTop ?? null;
    }

    get waterBodyPressureIncreaseCoefKzInc() {
        return this.waterBody?.waterBodyPressureIncreaseCoefKzInc ?? null;
    }

    get geoType() {
        return this.geoLayer?.geoType ?? null;
    }

    get k0CalcMethod() {
        return this.geoType?.k0CalcMethod ?? null;
    }

    get coefficientOfLateralEarthPressureAtRestK0() {
        return this.geoType?.coefficientOfLateralEarthPressureAtRestK0 ?? null;
    }

    get bulkUnitWeightGama() {
        return this.geoType?.bulkUnitWeightGama ?? null;
    }

    get dryUnitWeightGamaD() {
        return this.geoType?.dryUnitWeightGamaD ?? null;
    }

    get saturatedUnitWeightGamaSat() {
        return this.geoType?.saturatedUnitWeightGamaSat ?? null;
    }

    get degreeOfSaturationSr() {
        return this.geoType?.degreeOfSaturationSr ?? null;
    }

    get moistureContentW() {
        return this.geoType?.moistureContentW ?? null;
    }

    get effectiveInternalFrictionAngleFiEf() {
        return this.geoType?.effectiveInternalFrictionAngleFiEf ?? null;
    }

    get effectiveCohesionCef() {
        return this.geoType?.effectiveCohesionCef ?? null;
    }

    get continuousUniformVerticalLoadP() {
        return this.load?.continuousUniformVerticalLoadP ?? null;
    }

}
